<template lang="pug">
portal(:to="`${constants.DIALOG_PORTAL_KEY}.content`")
  event-agreement-info(
    v-bind="$attrs"
  )
</template>

<script>
import EventAgreementInfo from '@/components/global/event-agreements/EventAgreementInfo.vue';

const DIALOG_PORTAL_KEY = 'agreement';

export default {
  name: 'AgreementModal',
  components: {
    EventAgreementInfo,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    inputValue: {
      handler(value) {
        if (!value) {
          return;
        }

        this.openModal();
      },
      immediate: true,
    },
  },
  methods: {
    openModal() {
      this.$dialogs.portal({
        attrs: {
          'max-width': 850,
          title: 'Согласие на обработку персональных данных',
          inputValue: DIALOG_PORTAL_KEY,
        },
        listeners: {
          close: this.closeModal,
          'click:outside': this.closeModal,
        },
      });
    },
    closeModal() {
      this.inputValue = false;
    },
  },
};
</script>
